export const CHART_COOKIE = Object.freeze({
  MSP_USAGE_CHART_SELECTED_SERVICE: "msp-usage-chart-selected-service",
  CUSTOMER_USAGE_CHART_SELECTED_SERVICE:
    "customer-usage-chart-selected-service",
});

export default {};
